import * as actionTypes from "./actionTypes";

export const updateApprovalListCount = (count) => {
  return {
    type: actionTypes.UPDATE_APPROVAL_LIST_COUNT,
    payload: count,
  };
};
